import React from 'react'

const InfoTag = () => (
    <div className='info-tag'>
      MUSE is a small project made by K. McClure (2018) for a coding challenge.
      It uses a React/redux/node.js stack built on the firebase database and cloud function hosting.
      If you'd like to know more, or get in touch with the developer,
      please visit <a href="http://www.koorogi.com">my website.</a>
    </div>
  )


export default InfoTag



// WEBPACK FOOTER //
// ./src/components/url-form/info-tag.js